import {
  Card,
  Divider,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Delete } from "@mui/icons-material";
import NullCheck from "../../../components/NullCheck";
import SelectInput from "components/files/SelectInput";

const ClientItems = ({ itemList, clientData, setItemList, control, errors }) => {
  const { bt } = useBizTypeTranslation();
  const [hasItem, setHasItem] = useState(true);

  useEffect(() => {
    if (clientData?.items?.length === 0) {
      setHasItem(false)
      addProd("")
    }
  }, [clientData]);

  const addProd = (selectedItem) => {
    if (selectedItem === 1) return;
    setItemList((list) => [...list, selectedItem]);
  };

  const removeProd = (id) => {
    let newList = [...itemList];
    newList = newList.filter((prod, index) => index !== id);
    setItemList(newList);
  };

  const changeItemText = (data) => {
    const text = data?.text;
    const indexItem = data?.indexItem;
    let newList = [...itemList];
    const item = newList[indexItem].split("-")[0];
    newList[indexItem] = `${item} - ${text}`;

    setItemList(newList);
  };

  if (!clientData) return;

  return (
    <Stack spacing={2}>
      <Stack direction="row" gap={2}>
        <NullCheck valueForCheck={clientData?.items?.length > 0}>
          <SelectInput
            width="100%"
            name="clientLocalItem"
            addFlex
            control={control}
            errors={errors}
            title="SELECT_ITEMS"
            required
            onChanged={(value) => value?.name ? addProd(value?.name) : null}
            options={clientData?.items?.map((item) => {
              return { name: item.name, id: item.name };
            })}
          />

        </NullCheck>

      </Stack>

      <List
        sx={{
          width: "100%",
          position: "relative",
          overflow: "auto",
          "& ul": { padding: 0 },
        }}
        subheader={<li />}
      >
        {itemList?.length > 0
          ? itemList?.map((item, index) => (
            <Fragment key={index}>
              <ListItem sx={{ paddingX: 0 }}>
                <Card sx={{ width: "100%", border: '1px solid #000' }}>

                  <Stack width='100%' spacing={1} pb={1} px={1}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {`${item?.split("-")[0]} - `}
                    </Typography>

                    <TextField
                      placeholder={bt("DESC_PROBLEM")}
                      multiline
                      maxRows={4}
                      rows={5}
                      onChange={(e) =>
                        changeItemText({ text: e.target.value, indexItem: index })
                      }
                    />
                  </Stack>

                  <Stack
                    padding={0.5}
                    alignItems='end'
                    width='100%'
                    borderTop='1px solid #000'
                    bgcolor="primary.main"
                  >
                    <IconButton size="small" onClick={() => removeProd(index)}>
                      <Delete sx={{ color: "error.main" }} />
                    </IconButton>
                  </Stack>

                </Card>
              </ListItem>
              <Divider />
            </Fragment>
          ))
          : null
        }
      </List>
    </Stack>
  );
};
export default ClientItems;
